export type ModoRestricao = 'BLOQUEAR' | 'PERMITIR' | 'LIBERAR';

/**
 * Todos os tipos de restrição possíveis em runtime (PDV + ERP).
 * Os 4 tipos configuráveis pelo admin no ERP são: VENDA_LIMITE_CREDITO,
 * VENDA_CLIENTE_DEVEDOR, DESCONTO_ACIMA_LIMITE e CANCELAMENTO_VENDA.
 */
export type TipoRestricao =
  | 'VENDA_CLIENTE_DEVEDOR'
  | 'VENDA_LIMITE_CREDITO'
  | 'SANGRIA'
  | 'DESCONTO_EXCEDIDO'
  | 'CLIENTE_BLOQUEADO'
  | 'CANCELAMENTO_VENDA'
  | 'DESCONTO_ACIMA_LIMITE'
  | 'ESTOQUE_NEGATIVO'
  | 'ALTERA_PRECO_VENDA';

/** Subset de tipos configuráveis pelo administrador no ERP. */
export type TipoRestricaoConfiguravel =
  | 'CANCELAMENTO_VENDA'
  | 'DESCONTO_ACIMA_LIMITE'
  | 'VENDA_CLIENTE_DEVEDOR'
  | 'VENDA_LIMITE_CREDITO';

export interface RestricaoItem {
  tipo: TipoRestricao;
  modo: ModoRestricao;
  valor?: number | null;
}

export const TODOS_TIPOS_RESTRICAO: TipoRestricaoConfiguravel[] = [
  'VENDA_LIMITE_CREDITO',
  'VENDA_CLIENTE_DEVEDOR',
  'DESCONTO_ACIMA_LIMITE',
  'CANCELAMENTO_VENDA',
];

export const LABEL_TIPO_RESTRICAO: Record<TipoRestricao, string> = {
  VENDA_LIMITE_CREDITO: 'Limite de Crédito',
  VENDA_CLIENTE_DEVEDOR: 'Cliente Devedor',
  DESCONTO_ACIMA_LIMITE: 'Desconto Acima do Limite',
  CANCELAMENTO_VENDA: 'Cancelamento de Venda',
  SANGRIA: 'Sangria',
  DESCONTO_EXCEDIDO: 'Desconto Excedido',
  CLIENTE_BLOQUEADO: 'Cliente Bloqueado',
  ESTOQUE_NEGATIVO: 'Estoque Negativo',
  ALTERA_PRECO_VENDA: 'Alteração de Preço de Venda',
};

export const OPCOES_MODO: { label: string; value: ModoRestricao | '' }[] = [
  { label: 'Bloquear', value: 'BLOQUEAR' },
  { label: 'Liberar (pede autorização)', value: 'LIBERAR' },
  { label: 'Permitir (sem restrição)', value: 'PERMITIR' },
];
